(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp4-business-banner"] && !Shopify.designMode) return;
  try {
    
  ;(() => {
    const focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'textarea:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
    ].join(',')

    let bodyScrollY = 0
    let activeModal = null
    let previousFocus = null
    const editorStateKey = '__lp4ComparisonPopupState'
    const editorState = (window[editorStateKey] = window[editorStateKey] || {})
    const scrollLockClass = 'lp4-comparison-popup-scroll-lock'
    const scrollTopProperty = '--lp4-comparison-popup-scroll-top'
    if (editorState.controller && typeof editorState.controller.abort === 'function') {
      editorState.controller.abort()
    }
    editorState.controller = null
    editorState.listenerVersion = (editorState.listenerVersion || 0) + 1
    const listenerVersion = editorState.listenerVersion
    const modalScrollTargets = [
      ['body', '[data-lp4-comparison-popup-body]'],
      ['table', '.lp4-comparison-popup-table-wrap'],
      ['mobileList', '.lp4-comparison-popup-mobile-compare__list'],
    ]

    const isDesignMode = () => Boolean(window.Shopify && window.Shopify.designMode)
    const isCurrentListener = () => editorState.listenerVersion === listenerVersion

    const getLockedScrollY = () => {
      const lockedTop = document.body.style.getPropertyValue(scrollTopProperty)
      const parsedTop = Number.parseFloat(lockedTop)
      if (Number.isFinite(parsedTop) && parsedTop < 0) return Math.abs(parsedTop)
      return bodyScrollY || window.scrollY || document.documentElement.scrollTop || 0
    }

    const getFocusable = (modal) =>
      Array.from(modal.querySelectorAll(focusableSelector)).filter((element) => {
        return (
          element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement
        )
      })

    const scrollExpandedAccordionToTop = (accordionItem, accordionRoot) => {
      if (!accordionItem || !accordionRoot) return
      if (!window.matchMedia('(max-width: 989px)').matches) return

      const list = accordionRoot.querySelector('.lp4-comparison-popup-mobile-compare__list')
      if (!list) return

      const listRect = list.getBoundingClientRect()
      const itemRect = accordionItem.getBoundingClientRect()
      const targetTop = list.scrollTop + itemRect.top - listRect.top
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

      list.scrollTo({
        top: targetTop,
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
      })
    }

    const lockBody = (scrollY) => {
      bodyScrollY = Number.isFinite(scrollY)
        ? scrollY
        : window.scrollY || document.documentElement.scrollTop || 0
      document.body.style.setProperty(scrollTopProperty, `-${bodyScrollY}px`)
      document.body.classList.add(scrollLockClass)
    }

    const unlockBody = (scrollY) => {
      const targetScrollY = Number.isFinite(scrollY) ? scrollY : bodyScrollY
      document.body.classList.remove(scrollLockClass)
      document.body.style.removeProperty(scrollTopProperty)
      window.scrollTo(0, targetScrollY)
    }

    const getModalScrollState = (modal) => {
      const state = {}

      modalScrollTargets.forEach(([key, selector]) => {
        const element = modal.querySelector(selector)
        if (!element) return

        state[key] = {
          left: element.scrollLeft,
          top: element.scrollTop,
        }
      })

      return state
    }

    const restoreModalScrollState = (modal, state) => {
      if (!state) return

      modalScrollTargets.forEach(([key, selector]) => {
        const position = state[key]
        if (!position) return

        const element = modal.querySelector(selector)
        if (!element) return

        element.scrollLeft = position.left || 0
        element.scrollTop = position.top || 0
      })
    }

    const openModal = (modal, trigger) => {
      if (!modal || activeModal === modal) return

      previousFocus = trigger || document.activeElement
      modal.hidden = false
      activeModal = modal
      lockBody()

      window.requestAnimationFrame(() => {
        const closeButton = modal.querySelector(
          '[data-lp4-comparison-popup-close]:not(.lp4-comparison-popup-modal__overlay)',
        )
        const body = modal.querySelector('[data-lp4-comparison-popup-body]')
        ;(body || closeButton || modal).focus({ preventScroll: true })
      })
    }

    const closeModal = (modal) => {
      const targetModal = modal || activeModal
      if (!targetModal) return

      targetModal.hidden = true
      activeModal = null
      unlockBody()

      if (previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus({ preventScroll: true })
      }
      previousFocus = null
    }

    const preserveEditorModal = (modal) => {
      const root = modal.closest('[data-lp4-comparison-popup-root]')
      const sectionId = root ? root.getAttribute('data-section-id') : ''
      const scrollY = getLockedScrollY()

      editorState.wasOpen = true
      editorState.sectionId = sectionId
      editorState.scrollY = scrollY
      editorState.modalScroll = getModalScrollState(modal)
      bodyScrollY = scrollY
      modal.hidden = true
      activeModal = null
      previousFocus = null

      if (editorState.unlockTimer) window.clearTimeout(editorState.unlockTimer)
      editorState.unlockTimer = window.setTimeout(() => {
        if (!editorState.wasOpen) return
        editorState.wasOpen = false
        unlockBody(editorState.scrollY)
      }, 2000)
    }

    const restoreEditorModal = (sectionRoot) => {
      if (!editorState.wasOpen || !sectionRoot) return

      const sectionId = sectionRoot.getAttribute('data-section-id') || ''
      if (editorState.sectionId && sectionId && editorState.sectionId !== sectionId) return

      const modal = sectionRoot.querySelector('[data-lp4-comparison-popup-modal]')
      if (!modal) return

      if (editorState.unlockTimer) window.clearTimeout(editorState.unlockTimer)

      bodyScrollY = Number.isFinite(editorState.scrollY) ? editorState.scrollY : getLockedScrollY()
      modal.hidden = false
      activeModal = modal
      previousFocus = null
      document.body.classList.add(scrollLockClass)
      document.body.style.setProperty(scrollTopProperty, `-${bodyScrollY}px`)
      editorState.wasOpen = false
      restoreModalScrollState(modal, editorState.modalScroll)

      window.requestAnimationFrame(() => {
        restoreModalScrollState(modal, editorState.modalScroll)
        const body = modal.querySelector('[data-lp4-comparison-popup-body]')
        ;(body || modal).focus({ preventScroll: true })

        window.requestAnimationFrame(() => {
          restoreModalScrollState(modal, editorState.modalScroll)
        })
      })
    }

    const findModalForTrigger = (trigger) => {
      const targetId =
        trigger.getAttribute('aria-controls') ||
        trigger.getAttribute('data-lp4-comparison-popup-target')
      if (targetId) return document.getElementById(targetId)

      const root = trigger.closest('[data-lp4-comparison-popup-root]')
      return root
        ? root.querySelector('[data-lp4-comparison-popup-modal]')
        : document.querySelector('[data-lp4-comparison-popup-modal]')
    }

    const getEventElement = (event) => {
      const target = event.target
      if (target instanceof Element) return target
      return target && target.parentElement ? target.parentElement : null
    }

    const toggleAccordionPanel = (accordionTrigger, event) => {
      if (event) {
        event.preventDefault()
        event.stopPropagation()
      }

      const modal = accordionTrigger.closest('[data-lp4-comparison-popup-modal]')
      const accordionRoot =
        accordionTrigger.closest('[data-lp4-comparison-popup-mobile-compare]') || modal
      const accordionItem = accordionTrigger.closest('.lp4-comparison-popup-mobile-compare__item')
      let panel = accordionItem
        ? accordionItem.querySelector('[data-lp4-comparison-popup-accordion-panel]')
        : null

      if (!panel && modal) {
        const panelId = accordionTrigger.getAttribute('aria-controls')
        panel = panelId ? modal.querySelector(`[id="${panelId}"]`) : null
      }

      if (!modal || !accordionRoot || !panel) return

      const nextExpanded = accordionTrigger.getAttribute('aria-expanded') !== 'true'
      accordionRoot
        .querySelectorAll('[data-lp4-comparison-popup-accordion-trigger]')
        .forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false')
        })
      accordionRoot
        .querySelectorAll('[data-lp4-comparison-popup-accordion-panel]')
        .forEach((item) => {
          item.hidden = true
        })

      accordionTrigger.setAttribute('aria-expanded', String(nextExpanded))
      panel.hidden = !nextExpanded

      if (nextExpanded && accordionItem) {
        window.requestAnimationFrame(() => {
          scrollExpandedAccordionToTop(accordionItem, accordionRoot)
        })
      }
    }

    const bindAccordionTriggers = (root) => {
      ;(root || document)
        .querySelectorAll('[data-lp4-comparison-popup-accordion-trigger]')
        .forEach((trigger) => {
          trigger.onclick = (event) => toggleAccordionPanel(trigger, event)
        })
    }

    bindAccordionTriggers()

    document.addEventListener('click', (event) => {
      if (!isCurrentListener()) return

      const eventTarget = getEventElement(event)
      if (!eventTarget) return

      const openTrigger = eventTarget.closest('[data-lp4-comparison-popup-open]')
      if (openTrigger) {
        event.preventDefault()
        openModal(findModalForTrigger(openTrigger), openTrigger)
        return
      }

      const closeTrigger = eventTarget.closest('[data-lp4-comparison-popup-close]')
      if (closeTrigger) {
        event.preventDefault()
        closeModal(closeTrigger.closest('[data-lp4-comparison-popup-modal]'))
        return
      }

      const accordionTrigger = eventTarget.closest('[data-lp4-comparison-popup-accordion-trigger]')
      if (accordionTrigger) {
        toggleAccordionPanel(accordionTrigger, event)
        return
      }
    })

    document.addEventListener('keydown', (event) => {
      if (!isCurrentListener()) return
      if (!activeModal) return

      if (event.key === 'Escape') {
        event.preventDefault()
        closeModal(activeModal)
        return
      }

      if (event.key !== 'Tab') return

      const focusable = getFocusable(activeModal)
      if (!focusable.length) {
        event.preventDefault()
        activeModal.focus()
        return
      }

      const first = focusable[0]
      const last = focusable[focusable.length - 1]

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault()
        last.focus()
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault()
        first.focus()
      }
    })

    document.addEventListener('shopify:block:select', (event) => {
      if (!isCurrentListener()) return
      if (!isDesignMode()) return

      const root = event.target.closest('[data-lp4-comparison-popup-root]')
      const modal = root ? root.querySelector('[data-lp4-comparison-popup-modal]') : null
      if (!modal) return

      if (modal.hidden) openModal(modal)
    })

    document.addEventListener('shopify:section:load', (event) => {
      if (!isCurrentListener()) return
      if (!isDesignMode()) return
      bindAccordionTriggers(event.target)
      restoreEditorModal(event.target)
    })

    document.addEventListener('shopify:section:unload', (event) => {
      if (!isCurrentListener()) return
      if (!activeModal) return

      const root = activeModal.closest('[data-lp4-comparison-popup-root]')
      if (isDesignMode() && root && event.target.contains(root)) {
        preserveEditorModal(activeModal)
        return
      }

      closeModal(activeModal)
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp4-faq"] && !Shopify.designMode) return;
  try {
    
  ;(() => {
    const initFaq = (root) => {
      if (!root || root.dataset.lp4FaqReady === 'true') return
      root.dataset.lp4FaqReady = 'true'

      root.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-lp4-faq-trigger]')
        if (!trigger || !root.contains(trigger)) return
        const item = trigger.closest('.lp4-faq__item')
        const panel = item && item.querySelector('[data-lp4-faq-panel]')
        if (!item || !panel) return

        const open = !item.classList.contains('is-active')
        item.classList.toggle('is-active', open)
        trigger.setAttribute('aria-expanded', String(open))
        panel.hidden = !open
      })
    }

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-lp4-faq]').forEach(initFaq)
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true })
    } else {
      initAll()
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target))
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp4-lds-workflow"] && !Shopify.designMode) return;
  try {
    
  ;(() => {
    window.lp4PrewarmMedia =
      window.lp4PrewarmMedia ||
      ((scope) => {
        if (!scope) return

        scope.querySelectorAll('img').forEach((img) => {
          img.loading = 'eager'
          if (img.dataset.lp4Prewarmed === 'true') return
          img.dataset.lp4Prewarmed = 'true'

          const preloader = new Image()
          preloader.decoding = 'async'
          preloader.sizes = img.sizes || img.getAttribute('sizes') || '100vw'
          if (img.srcset) preloader.srcset = img.srcset
          preloader.src = img.currentSrc || img.src
          if (preloader.decode) preloader.decode().catch(() => {})
        })

        if (scope.querySelector('video[data-responsive-video]')) {
          document.dispatchEvent(
            new CustomEvent('responsive-video:prepare', {
              detail: { root: scope, options: { play: false } },
            }),
          )
        }
      })

    const setActiveDot = (dots, index) => {
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index)
      })
    }

    const initRoot = (root) => {
      if (!root || root.dataset.lp4LdsWorkflowReady === 'true') return
      root.dataset.lp4LdsWorkflowReady = 'true'

      const tabs = Array.from(root.querySelectorAll('[data-lp4-lds-workflow-tab]'))
      const panels = Array.from(root.querySelectorAll('[data-lp4-lds-workflow-panel]'))
      const panelsViewport = root.querySelector('[data-lp4-lds-workflow-panels]')
      const mobileQuery = window.matchMedia('(max-width: 749px)')
      const USE_CASE_SCROLL_PADDING = 23.5
      let useCaseScrollLock = false
      let useCaseScrollLockTimer = 0

      const releaseUseCaseScrollLock = () => {
        useCaseScrollLock = false
        syncUseCaseFromScrollPosition()
      }

      const lockUseCaseScroll = (behavior) => {
        useCaseScrollLock = true
        window.clearTimeout(useCaseScrollLockTimer)

        if (behavior === 'auto') {
          useCaseScrollLock = false
          return
        }

        if ('onscrollend' in (panelsViewport || {})) {
          panelsViewport.addEventListener('scrollend', releaseUseCaseScrollLock, { once: true })
          return
        }

        useCaseScrollLockTimer = window.setTimeout(releaseUseCaseScrollLock, 450)
      }

      const syncUseCaseFromScrollPosition = () => {
        if (!mobileQuery.matches || !panelsViewport || panels.length === 0) return

        const viewportCenter = panelsViewport.scrollLeft + panelsViewport.clientWidth / 2
        const activePanel = panels.reduce(
          (closest, panel) => {
            const center = panel.offsetLeft + panel.offsetWidth / 2
            const distance = Math.abs(center - viewportCenter)
            return distance < closest.distance ? { distance, panel } : closest
          },
          { distance: Number.POSITIVE_INFINITY, panel: panels[0] },
        ).panel

        if (activePanel) setUseCaseActive(activePanel.dataset.lp4LdsWorkflowPanel)
      }

      const setUseCaseActive = (target, options = {}) => {
        const targetPanel = root.querySelector(`[data-lp4-lds-workflow-panel="${target}"]`)
        window.lp4PrewarmMedia(targetPanel)

        tabs.forEach((item) => {
          const active = item.dataset.lp4LdsWorkflowTab === target
          item.classList.toggle('is-active', active)
          item.setAttribute('aria-selected', String(active))
        })

        panels.forEach((panel) => {
          const active = panel.dataset.lp4LdsWorkflowPanel === target
          panel.classList.toggle('is-active', active)
          panel.hidden = mobileQuery.matches ? false : !active
        })

        if (options.scroll && mobileQuery.matches && targetPanel && panelsViewport) {
          const behavior = options.instant ? 'auto' : 'smooth'
          lockUseCaseScroll(behavior)
          panelsViewport.scrollTo({
            left: targetPanel.offsetLeft - USE_CASE_SCROLL_PADDING,
            behavior,
          })
        }
      }

      const syncUseCaseVisibility = () => {
        const activeTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0]
        if (activeTab) setUseCaseActive(activeTab.dataset.lp4LdsWorkflowTab, { instant: true })
      }

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.lp4LdsWorkflowTab
          setUseCaseActive(target, { scroll: true })
        })

        tab.addEventListener(
          'pointerover',
          () => {
            window.lp4PrewarmMedia(
              root.querySelector(
                `[data-lp4-lds-workflow-panel="${tab.dataset.lp4LdsWorkflowTab}"]`,
              ),
            )
          },
          { passive: true },
        )
      })

      if (panelsViewport && panels.length) {
        let useCaseScrollEndTimer = 0
        const updateUseCaseFromScroll = () => {
          window.clearTimeout(useCaseScrollEndTimer)
          useCaseScrollEndTimer = window.setTimeout(() => {
            if (useCaseScrollLock) return
            syncUseCaseFromScrollPosition()
          }, 120)
        }

        panelsViewport.addEventListener('scroll', updateUseCaseFromScroll, { passive: true })
      }

      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', syncUseCaseVisibility)
      } else if (mobileQuery.addListener) {
        mobileQuery.addListener(syncUseCaseVisibility)
      }
      syncUseCaseVisibility()

      const prewarmPanels = () => {
        panels.forEach(window.lp4PrewarmMedia)
      }
      window.lp4PrewarmMedia(root.querySelector('[data-lp4-lds-workflow-panel].is-active') || root)
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(prewarmPanels, { timeout: 1600 })
      } else {
        window.setTimeout(prewarmPanels, 300)
      }

      const steps = root.querySelector('[data-lp4-lds-workflow-steps]')
      const stepItems = Array.from(root.querySelectorAll('[data-lp4-lds-workflow-step]'))
      const stepDots = Array.from(root.querySelectorAll('[data-lp4-lds-workflow-step-dot]'))
      const STEP_SCROLL_PADDING = 23.5
      const STEP_GAP = 16
      let stepsScrollLock = false
      let stepsScrollLockTimer = 0
      let stepsFrame = 0

      const getStepIndexFromScroll = () => {
        if (!steps || stepItems.length === 0) return 0
        const stride = stepItems[0].offsetWidth + STEP_GAP
        if (!stride) return 0
        const index = Math.round((steps.scrollLeft - STEP_SCROLL_PADDING) / stride)
        return Math.max(0, Math.min(stepDots.length - 1, index))
      }

      const setStepDotActive = (index) => {
        setActiveDot(stepDots, index)
        stepDots.forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false')
        })
      }

      const releaseStepsScrollLock = () => {
        stepsScrollLock = false
        setStepDotActive(getStepIndexFromScroll())
      }

      const scrollToStep = (index, behavior = 'smooth') => {
        const item = stepItems[index]
        if (!steps || !item) return

        stepsScrollLock = true
        window.clearTimeout(stepsScrollLockTimer)
        setStepDotActive(index)

        steps.scrollTo({
          left: Math.max(0, item.offsetLeft - STEP_SCROLL_PADDING),
          behavior,
        })

        if (behavior === 'auto') {
          stepsScrollLock = false
          return
        }

        if ('onscrollend' in steps) {
          steps.addEventListener('scrollend', releaseStepsScrollLock, { once: true })
          return
        }

        stepsScrollLockTimer = window.setTimeout(releaseStepsScrollLock, 450)
      }

      if (steps && stepItems.length && stepDots.length) {
        stepDots.forEach((dot, index) => {
          dot.addEventListener('click', () => scrollToStep(index))
        })

        steps.addEventListener(
          'scroll',
          () => {
            window.cancelAnimationFrame(stepsFrame)
            stepsFrame = window.requestAnimationFrame(() => {
              if (stepsScrollLock) return
              setStepDotActive(getStepIndexFromScroll())
            })
          },
          { passive: true },
        )

        setStepDotActive(getStepIndexFromScroll())
      }

      const preview = root.querySelector('[data-lp4-lds-workflow-preview]')
      if (preview) {
        preview.addEventListener('click', () => {
          const video = preview.querySelector('video')
          if (!video) return
          if (window.__responsiveVideoLoader && window.__responsiveVideoLoader.load) {
            window.__responsiveVideoLoader.load(video, { play: true })
          } else {
            document.dispatchEvent(
              new CustomEvent('responsive-video:prepare', {
                detail: { root: preview, options: { play: true } },
              }),
            )
          }
          const promise = video.play()
          if (promise && typeof promise.catch === 'function') promise.catch(() => {})
        })
      }
    }

    const initAll = () => {
      document.querySelectorAll('[data-lp4-lds-workflow]').forEach(initRoot)
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true })
    } else {
      initAll()
    }

    document.addEventListener('shopify:section:load', (event) => {
      initRoot(event.target.querySelector('[data-lp4-lds-workflow]'))
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp4-material-switcher"] && !Shopify.designMode) return;
  try {
    
  ;(() => {
    const getLaserKey = (panel) => panel?.dataset.lp4MaterialSwitcherLaserPanel || ''

    const getLaserPanelId = (panel) => panel?.dataset.lp4MaterialSwitcherLaserPanelId || ''

    const getLaserPanels = (root) =>
      Array.from(root.querySelectorAll('[data-lp4-material-switcher-laser-panel]'))

    const findLaserPanel = (root, target) => {
      if (!root || !target) return null

      const panels = getLaserPanels(root)
      return (
        panels.find((panel) => getLaserPanelId(panel) === target) ||
        panels.find((panel) => getLaserKey(panel) === target) ||
        null
      )
    }

    const activateLaserPanel = (root, targetPanel) => {
      if (!root || !targetPanel) return

      let matched = false
      getLaserPanels(root).forEach((panel) => {
        const active = panel === targetPanel
        matched = matched || active
        const trigger = panel.querySelector('[data-lp4-material-switcher-laser]')
        panel.classList.toggle('is-active', active)
        if (trigger) trigger.setAttribute('aria-expanded', String(active))
      })

      if (matched) syncMaterials(root, getLaserKey(targetPanel))
    }

    const activateLaser = (root, target) => {
      activateLaserPanel(root, findLaserPanel(root, target))
    }

    const initLaserStack = (root) => {
      if (!root || root.dataset.lp4MaterialSwitcherLaserReady === 'true') return
      root.dataset.lp4MaterialSwitcherLaserReady = 'true'

      root.addEventListener('click', (event) => {
        const laser = event.target.closest('[data-lp4-material-switcher-laser]')
        if (!laser || !root.contains(laser)) return

        const panel = laser.closest('[data-lp4-material-switcher-laser-panel]')
        activateLaserPanel(root, panel)
      })

      const activePanel = root.querySelector('[data-lp4-material-switcher-laser-panel].is-active')
      const initialPanel =
        activePanel || root.querySelector('[data-lp4-material-switcher-laser-panel]')
      activateLaserPanel(root, initialPanel)
    }

    const syncMaterials = (root, laserKey) => {
      const materialCard = root.querySelector('.lp4-material-switcher__material-card')
      if (!materialCard) return

      const tabs = Array.from(
        materialCard.querySelectorAll(
          '[data-lp4-tabs-trigger][data-lp4-material-switcher-material-laser]',
        ),
      )
      const panels = Array.from(
        materialCard.querySelectorAll(
          '[data-lp4-tabs-panel][data-lp4-material-switcher-material-laser]',
        ),
      )
      const visibleTabs = tabs.filter(
        (item) => item.dataset.lp4MaterialSwitcherMaterialLaser === laserKey,
      )
      const hasVisibleTabs = visibleTabs.length > 0

      materialCard.classList.toggle('is-empty', !hasVisibleTabs)
      root.classList.toggle('lp4-material-switcher--laser-only', !hasVisibleTabs)

      tabs.forEach((item) => {
        const visible = item.dataset.lp4MaterialSwitcherMaterialLaser === laserKey
        item.hidden = !visible
        if (!visible) {
          item.classList.remove('is-active')
          item.setAttribute('aria-selected', 'false')
        }
      })

      panels.forEach((item) => {
        const visible = item.dataset.lp4MaterialSwitcherMaterialLaser === laserKey
        item.hidden = !visible
        if (!visible) item.classList.remove('is-active')
      })

      if (!hasVisibleTabs) return

      const activeVisibleTab =
        visibleTabs.find((item) => item.classList.contains('is-active')) || visibleTabs[0]
      if (!activeVisibleTab) return

      const target = activeVisibleTab.dataset.lp4TabsTrigger
      tabs.forEach((item) => {
        const active = item === activeVisibleTab
        item.classList.toggle('is-active', active)
        item.setAttribute('aria-selected', String(active))
      })
      panels.forEach((item) => {
        const active = item.dataset.lp4TabsPanel === target
        item.classList.toggle('is-active', active)
        item.hidden = !active
        if (active && window.lp4PrewarmMedia) window.lp4PrewarmMedia(item)
      })
    }

    const initAll = () => {
      document.querySelectorAll('[data-lp4-material-switcher]').forEach(initLaserStack)
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true })
    } else {
      initAll()
    }

    document.addEventListener('shopify:section:load', (event) => {
      initLaserStack(event.target.querySelector('[data-lp4-material-switcher]'))
    })

    document.addEventListener('shopify:block:select', (event) => {
      const selectedBlockId = event.detail?.blockId || ''
      const panel =
        event.target.closest('[data-lp4-material-switcher-laser-panel]') ||
        Array.from(document.querySelectorAll('[data-lp4-material-switcher-laser-panel]')).find(
          (item) => getLaserPanelId(item) === selectedBlockId,
        )

      if (!panel) return

      const root = panel.closest('[data-lp4-material-switcher]')
      if (!root) return

      activateLaserPanel(root, panel)
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp4-product-hero"] && !Shopify.designMode) return;
  try {
    
  ;(() => {
    const initRoot = (root) => {
      if (!root || root.dataset.lp4ProductHeroVideoReady === 'true') return
      root.dataset.lp4ProductHeroVideoReady = 'true'

      const trigger = root.querySelector('[data-lp4-product-hero-video-trigger]')
      const modal = root.querySelector('[data-lp4-product-hero-video-modal]')
      const close = root.querySelector('[data-lp4-product-hero-video-close]')
      const video = modal && modal.querySelector('video[data-responsive-video]')
      const youtubeFrame = modal && modal.querySelector('[data-lp4-product-hero-youtube]')
      if (!trigger || !modal || (!video && !youtubeFrame)) return
      if (modal.parentElement !== document.body) document.body.appendChild(modal)

      const prepare = (play) => {
        if (window.__responsiveVideoLoader && window.__responsiveVideoLoader.load) {
          window.__responsiveVideoLoader.load(video, { play })
        } else {
          document.dispatchEvent(
            new CustomEvent('responsive-video:prepare', {
              detail: { root: modal, options: { play } },
            }),
          )
        }
      }

      const loadYouTube = () => {
        if (!youtubeFrame || youtubeFrame.querySelector('iframe')) return

        const iframe = document.createElement('iframe')
        iframe.src = youtubeFrame.dataset.youtubeSrc
        iframe.title = youtubeFrame.dataset.youtubeTitle || 'YouTube video player'
        iframe.allow =
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
        iframe.referrerPolicy = 'strict-origin-when-cross-origin'
        iframe.allowFullscreen = true
        youtubeFrame.appendChild(iframe)
      }

      const unloadYouTube = () => {
        if (!youtubeFrame) return
        youtubeFrame.textContent = ''
      }

      const open = () => {
        modal.hidden = false
        document.documentElement.classList.add('lp4-video-modal-open')
        if (youtubeFrame) {
          loadYouTube()
        } else {
          prepare(true)
        }
        close.focus({ preventScroll: true })
      }

      const closeModal = () => {
        modal.hidden = true
        document.documentElement.classList.remove('lp4-video-modal-open')
        if (video) video.pause()
        unloadYouTube()
        trigger.focus({ preventScroll: true })
      }

      if (video) {
        trigger.addEventListener('pointerover', () => prepare(false), { passive: true })
        trigger.addEventListener('focus', () => prepare(false))
      }
      trigger.addEventListener('click', open)
      close.addEventListener('click', closeModal)
      modal.addEventListener('click', (event) => {
        if (event.target === modal) closeModal()
      })
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !modal.hidden) closeModal()
      })
    }

    const initAll = (scope = document) => {
      scope.querySelectorAll('.lp4-product-hero').forEach(initRoot)
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true })
    } else {
      initAll()
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target))
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp4-profit-cards"] && !Shopify.designMode) return;
  try {
    
  ;(() => {
    const initProfitCards = (root) => {
      if (!root || root.dataset.lp4ProfitCardsReady === 'true') return
      root.dataset.lp4ProfitCardsReady = 'true'

      const viewport = root.querySelector('[data-lp4-profit-cards-track]')
      const cards = Array.from(root.querySelectorAll('[data-lp4-profit-cards-card]')).filter(
        (card) => card.getAttribute('aria-hidden') !== 'true',
      )
      const dots = Array.from(root.querySelectorAll('[data-lp4-profit-cards-dot]'))
      if (!viewport || cards.length === 0 || dots.length === 0) return

      let ticking = false
      let scrollLock = false
      let scrollLockTimer = 0
      const SCROLL_PADDING = 24

      const setActive = (index) => {
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index
          dot.classList.toggle('is-active', active)
          dot.setAttribute('aria-current', active ? 'true' : 'false')
        })
      }

      const syncActiveFromScroll = () => {
        const viewportRect = viewport.getBoundingClientRect()
        const reference = viewportRect.left + SCROLL_PADDING
        const target = cards.reduce(
          (closest, card, index) => {
            const distance = Math.abs(card.getBoundingClientRect().left - reference)
            return distance < closest.distance ? { distance, index } : closest
          },
          { distance: Number.POSITIVE_INFINITY, index: 0 },
        )
        setActive(target.index)
      }

      const releaseScrollLock = () => {
        scrollLock = false
        syncActiveFromScroll()
      }

      const scrollToCard = (index, behavior = 'smooth') => {
        const target = cards[index]
        if (!target) return

        scrollLock = true
        window.clearTimeout(scrollLockTimer)
        setActive(index)

        viewport.scrollTo({
          left: Math.max(0, target.offsetLeft - SCROLL_PADDING),
          behavior,
        })

        if (behavior === 'auto') {
          scrollLock = false
          return
        }

        if ('onscrollend' in viewport) {
          viewport.addEventListener('scrollend', releaseScrollLock, { once: true })
          return
        }

        scrollLockTimer = window.setTimeout(releaseScrollLock, 450)
      }

      const update = () => {
        ticking = false
        if (scrollLock) return
        syncActiveFromScroll()
      }

      const requestUpdate = () => {
        if (ticking) return
        ticking = true
        window.requestAnimationFrame(update)
      }

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = Number(dot.dataset.lp4ProfitCardsDot || 0)
          scrollToCard(index)
        })
      })

      viewport.addEventListener('scroll', requestUpdate, { passive: true })
      window.addEventListener('resize', requestUpdate)
      update()

      const prewarmCard = (card) => {
        if (!card) return
        if (window.lp4PrewarmMedia) {
          window.lp4PrewarmMedia(card)
          return
        }

        card.querySelectorAll('img').forEach((img) => {
          img.loading = 'eager'
          if (img.dataset.lp4Prewarmed === 'true') return
          img.dataset.lp4Prewarmed = 'true'

          const preloader = new Image()
          preloader.decoding = 'async'
          preloader.sizes = img.sizes || img.getAttribute('sizes') || '100vw'
          if (img.srcset) preloader.srcset = img.srcset
          preloader.src = img.currentSrc || img.src
          if (preloader.decode) preloader.decode().catch(() => {})
        })
      }

      const prewarmAll = () => cards.forEach(prewarmCard)
      cards.slice(0, 4).forEach(prewarmCard)
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(prewarmAll, { timeout: 1600 })
      } else {
        window.setTimeout(prewarmAll, 300)
      }
    }

    const initAll = () => {
      document.querySelectorAll('[data-lp4-profit-cards]').forEach(initProfitCards)
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true })
    } else {
      initAll()
    }

    document.addEventListener('shopify:section:load', (event) => {
      initProfitCards(event.target.querySelector('[data-lp4-profit-cards]'))
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp4-side-navigation"] && !Shopify.designMode) return;
  try {
    
  ;(() => {
    let initialized = false
    let scrollTicking = false
    let clickLockTarget = ''
    let clickLockTimer = 0
    let stickyStart = 0
    const sideHiddenSelectors = ['.lp4-profit-cards']

    const resolveTarget = (selector) => {
      if (!selector) return null
      try {
        return document.querySelector(selector)
      } catch (_) {
        return null
      }
    }

    const getRoot = () => document.querySelector('[data-lp4-side-navigation-root]')
    const getStickyNav = () => getRoot()?.querySelector('[data-lp4-nav-kind="sticky"]')
    const getStickySpacer = () => getRoot()?.querySelector('.lp4-secondary-nav__spacer')
    const getOverview = () => getRoot()?.querySelector('[data-lp4-nav-overview]')
    const selectorToId = (selector) => {
      if (!selector) return ''
      const firstChar = selector.charAt(0)
      if (firstChar === '#' || firstChar === '.') return selector.slice(1)
      return /^[A-Za-z][A-Za-z0-9_-]*$/.test(selector) ? selector : ''
    }

    const isPinnedHeader = (node) => {
      if (!node) return false
      const style = getComputedStyle(node)
      if (style.display === 'none' || style.visibility === 'hidden') return false
      return style.position === 'fixed' || style.position === 'sticky'
    }

    const getHeaderHeight = () => {
      const candidates = [
        document.querySelector('.airiosoft_main_navigation_wrapper'),
        document.querySelector('.airiosoft_main_navigation_height'),
        document.querySelector('.shopify-section-header-sticky'),
        document.querySelector('sticky-header'),
        document.querySelector('.header-wrapper'),
      ]
      const measured = candidates.reduce((height, node) => {
        if (!isPinnedHeader(node)) return height
        return Math.max(height, node.getBoundingClientRect().height)
      }, 0)
      if (measured <= 0) return 0
      const bodyValue =
        parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0
      return Math.max(bodyValue, measured)
    }

    const syncStickyTop = () => {
      const headerHeight = getHeaderHeight()
      const sticky = getStickyNav()
      const stickyBottom =
        sticky && getComputedStyle(sticky).display !== 'none'
          ? sticky.getBoundingClientRect().bottom
          : headerHeight
      document.documentElement.style.setProperty('--lp4-secondary-nav-top', `${headerHeight}px`)
      document.documentElement.style.setProperty(
        '--lp4-secondary-nav-mobile-top',
        `${headerHeight}px`,
      )
      document.documentElement.style.setProperty(
        '--lp4-secondary-nav-dropdown-top',
        `${Math.max(0, stickyBottom)}px`,
      )
      return headerHeight
    }

    const getOffset = () => {
      const headerHeight = syncStickyTop()
      const sticky = getStickyNav()
      const stickyHeight =
        sticky && getComputedStyle(sticky).display !== 'none'
          ? sticky.getBoundingClientRect().height
          : 0
      return headerHeight + stickyHeight + 16
    }

    const updateStickyState = () => {
      const sticky = getStickyNav()
      const spacer = getStickySpacer()
      const visible = sticky && getComputedStyle(sticky).display !== 'none'
      const stuck = Boolean(visible && window.scrollY >= stickyStart)
      const pairs = getPairs()
      const lastTarget = pairs.length ? pairs[pairs.length - 1].target : null
      const lastBottom = lastTarget
        ? lastTarget.getBoundingClientRect().bottom + window.scrollY
        : Number.POSITIVE_INFINITY
      const footerTarget = document.querySelector('footer, .footer')
      const footerTop = footerTarget
        ? footerTarget.getBoundingClientRect().top + window.scrollY
        : Number.POSITIVE_INFINITY
      const sideMarker = window.scrollY + window.innerHeight * 0.5
      const firstTarget = pairs.length ? pairs[0].target : null
      const firstTop = firstTarget
        ? firstTarget.getBoundingClientRect().top + window.scrollY
        : Number.NEGATIVE_INFINITY
      const afterFirst = sideMarker >= firstTop
      const beforeFooter = sideMarker < Math.min(lastBottom, footerTop)
      const overHiddenSection = sideHiddenSelectors.some((selector) => {
        const target = document.querySelector(selector)
        if (!target) return false
        const rect = target.getBoundingClientRect()
        const top = rect.top + window.scrollY
        const bottom = rect.bottom + window.scrollY
        return sideMarker >= top && sideMarker <= bottom
      })

      if (sticky) sticky.classList.toggle('is-stuck', stuck)
      if (spacer) spacer.classList.toggle('is-active', stuck)
      syncStickyTop()
      ;(getRoot()?.querySelectorAll('[data-lp4-nav-kind="side"]') || []).forEach((nav) => {
        nav.classList.toggle(
          'is-visible',
          stuck && afterFirst && beforeFooter && !overHiddenSection,
        )
      })
    }

    const measureStickyStart = () => {
      const sticky = getStickyNav()
      const spacer = getStickySpacer()
      const headerHeight = syncStickyTop()

      if (!sticky || getComputedStyle(sticky).display === 'none') {
        stickyStart = Number.POSITIVE_INFINITY
        updateStickyState()
        return
      }

      const wasStuck = sticky.classList.contains('is-stuck')
      if (wasStuck) {
        sticky.classList.remove('is-stuck')
        if (spacer) spacer.classList.remove('is-active')
      }

      stickyStart = sticky.getBoundingClientRect().top + window.scrollY - headerHeight

      if (wasStuck) {
        sticky.classList.add('is-stuck')
        if (spacer) spacer.classList.add('is-active')
      }

      updateStickyState()
    }

    const getPairs = () => {
      const selectors = []
      ;(getRoot()?.querySelectorAll('[data-lp4-side-nav-target]') || []).forEach((button) => {
        const selector = button.dataset.lp4SideNavTarget
        if (selector && !selectors.includes(selector)) selectors.push(selector)
      })

      return selectors
        .map((selector) => {
          const target = resolveTarget(selector)
          const targetId = selectorToId(selector)
          if (target && targetId && !target.id && !document.getElementById(targetId)) {
            target.id = targetId
          }
          return { selector, target }
        })
        .filter((item) => item.target)
        .sort((a, b) => {
          const aTop = a.target.getBoundingClientRect().top + window.scrollY
          const bTop = b.target.getBoundingClientRect().top + window.scrollY
          return aTop - bTop
        })
    }

    const setActive = (selector) => {
      let theme = 'light'
      let activeDropdown = false
      ;(getRoot()?.querySelectorAll('[data-lp4-side-nav-target]') || []).forEach((button) => {
        const active = button.dataset.lp4SideNavTarget === selector
        button.classList.toggle('is-active', active)
        if (active) {
          button.setAttribute('aria-current', 'true')
        } else {
          button.removeAttribute('aria-current')
        }
        if (active && button.closest('[data-lp4-secondary-nav-dropdown-list]')) {
          activeDropdown = true
        }
        if (active && button.dataset.lp4SideNavTheme === 'dark') theme = 'dark'
      })
      getRoot()
        ?.querySelectorAll('.lp4-secondary-nav__overview-summary')
        .forEach((summary) => {
          summary.classList.toggle('is-active', activeDropdown)
        })
      ;(getRoot()?.querySelectorAll('[data-lp4-side-nav]') || []).forEach((nav) => {
        nav.classList.toggle('is-dark', theme === 'dark')
      })
      syncActiveIntoView(selector)
    }

    const isElementVisible = (element) =>
      Boolean(
        element && (element.offsetWidth || element.offsetHeight || element.getClientRects().length),
      )

    const getActiveScrollContainer = (container) => {
      if (!container) return null
      if (container.matches('[data-lp4-secondary-nav-list]')) {
        return container.closest('.lp4-secondary-nav__inner') || container
      }
      return container
    }

    const scrollButtonToCenter = (button, scrollContainer, behavior) => {
      if (!button || !isElementVisible(scrollContainer)) return
      const buttonRect = button.getBoundingClientRect()
      const containerRect = scrollContainer.getBoundingClientRect()
      if (!buttonRect.width || !containerRect.width) return

      const targetLeft =
        scrollContainer.scrollLeft +
        buttonRect.left -
        containerRect.left -
        (containerRect.width - buttonRect.width) / 2
      const maxLeft = Math.max(0, scrollContainer.scrollWidth - scrollContainer.clientWidth)

      scrollContainer.scrollTo({
        left: Math.min(maxLeft, Math.max(0, targetLeft)),
        behavior,
      })
    }

    const syncActiveIntoView = (selector) => {
      const root = getRoot()
      if (!root || !selector) return
      syncStickyTop()
      const motionReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      const behavior = motionReduced ? 'auto' : 'smooth'
      const containers = root.querySelectorAll(
        '[data-lp4-secondary-nav-list], [data-lp4-secondary-nav-dropdown-list]',
      )
      containers.forEach((container) => {
        const activeButton = Array.from(
          container.querySelectorAll('[data-lp4-side-nav-target]'),
        ).find((button) => button.dataset.lp4SideNavTarget === selector)
        if (!activeButton) return
        scrollButtonToCenter(activeButton, getActiveScrollContainer(container), behavior)
      })
    }

    const updateActive = () => {
      scrollTicking = false
      updateStickyState()
      if (clickLockTarget) {
        setActive(clickLockTarget)
        return
      }

      const pairs = getPairs()
      if (pairs.length === 0) return

      const doc = document.documentElement
      if (window.scrollY + window.innerHeight >= doc.scrollHeight - 12) {
        setActive(pairs[pairs.length - 1].selector)
        return
      }

      const marker = window.scrollY + getOffset() + 4
      let active = pairs[0]
      pairs.forEach((pair) => {
        const top = pair.target.getBoundingClientRect().top + window.scrollY
        if (top <= marker) active = pair
      })
      setActive(active.selector)
    }

    const requestUpdate = () => {
      if (scrollTicking) return
      scrollTicking = true
      window.requestAnimationFrame(updateActive)
    }

    const onClick = (event) => {
      const button = event.target.closest('[data-lp4-side-nav-target]')
      if (!button) return

      const selector = button.dataset.lp4SideNavTarget
      const target = resolveTarget(selector)
      if (!target) return
      event.preventDefault()
      getOverview()?.removeAttribute('open')

      const top = target.getBoundingClientRect().top + window.scrollY - getOffset()
      clickLockTarget = selector
      setActive(selector)
      window.clearTimeout(clickLockTimer)
      clickLockTimer = window.setTimeout(() => {
        clickLockTarget = ''
        updateActive()
      }, 2200)

      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' })
    }

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-lp4-side-nav]').forEach((nav) => {
        if (nav.dataset.lp4SideNavReady === 'true') return
        nav.dataset.lp4SideNavReady = 'true'
        const overview = nav.querySelector('.lp4-secondary-nav__overview')
        overview?.addEventListener('toggle', () => {
          syncStickyTop()
          if (!overview.open) return
          window.requestAnimationFrame(() => {
            const activeButton = nav.querySelector('[data-lp4-side-nav-target].is-active')
            if (activeButton?.dataset.lp4SideNavTarget) {
              syncActiveIntoView(activeButton.dataset.lp4SideNavTarget)
            }
          })
        })
      })

      if (initialized) {
        updateActive()
        return
      }

      initialized = true
      document.addEventListener('click', onClick)
      window.addEventListener('scroll', requestUpdate, { passive: true })
      window.addEventListener('resize', () => {
        measureStickyStart()
        requestUpdate()
      })
      window.addEventListener(
        'load',
        () => {
          measureStickyStart()
          requestUpdate()
        },
        { once: true },
      )
      measureStickyStart()
      updateActive()
      window.setTimeout(() => {
        measureStickyStart()
        requestUpdate()
      }, 800)
      window.setTimeout(() => {
        measureStickyStart()
        requestUpdate()
      }, 2200)
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true })
    } else {
      initAll()
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target))
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp4-spec"] && !Shopify.designMode) return;
  try {
    
  ;(() => {
    const init = (root) => {
      if (!root || root.dataset.lp4SpecReady === 'true') return

      root.dataset.lp4SpecReady = 'true'

      root.querySelectorAll('[data-lp4-spec-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
          const expanded = root.getAttribute('data-lp4-spec-state') === 'expanded'

          root.setAttribute('data-lp4-spec-state', expanded ? 'collapsed' : 'expanded')
          button.setAttribute('aria-expanded', expanded ? 'false' : 'true')
        })
      })
    }

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-lp4-spec]').forEach(init)
    }

    initAll()

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target)
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const stickyHeader = document.querySelector('sticky-header')
    if (stickyHeader) {
      stickyHeader.setupWindowResizeEvent()
    }
  })

  } catch(e) { console.error(e); }
})();
})();
